/**
 * Voice search — attaches Web Speech API to any button with [data-voice-for="inputId"].
 * When a transcript lands, sets the input value and submits the form.
 * Silently hides the button when SpeechRecognition is unavailable.
 */
(function () {
  'use strict';

  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;

  function attach(btn) {
    const inputEl = document.getElementById(btn.dataset.voiceFor);
    if (!inputEl) return;

    if (!SR) { btn.hidden = true; return; }

    const form = inputEl.closest('form');
    const rec = new SR();
    rec.continuous = false;
    rec.interimResults = false;
    rec.lang = 'en-US';
    rec.maxAlternatives = 1;

    let listening = false;

    btn.addEventListener('click', function () {
      if (listening) { rec.abort(); return; }
      try { rec.start(); } catch (_) {}
    });

    rec.onstart = function () {
      listening = true;
      btn.classList.add('voice-search-btn--listening');
      btn.setAttribute('aria-label', 'Listening… tap to stop');
    };

    rec.onend = function () {
      listening = false;
      btn.classList.remove('voice-search-btn--listening');
      btn.setAttribute('aria-label', 'Search by voice');
    };

    rec.onresult = function (ev) {
      const q = ev.results[0][0].transcript.trim();
      if (!q) return;
      inputEl.value = q;
      if (form) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    };

    rec.onerror = function () {
      listening = false;
      btn.classList.remove('voice-search-btn--listening');
      btn.setAttribute('aria-label', 'Search by voice');
    };
  }

  function init() {
    document.querySelectorAll('[data-voice-for]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
